module.exports = __webpack_public_path__ + "img/rating-icon.1ca0c91.svg";